<a class="ui-version-switch no-link-style" [href]="legacyHref | apiurl">{{ 'Back to the old view' | tt }}</a>
